// Array of field configurations

export const breadcrumbItems = [{ label: "Config", link: "/auth/config" }];
